/**
 * [br-sp] / [br-pc] をレスポンシブ用の br 要素に変換する
 *
 * @param {Node} root
 */
const replaceResponsiveBreaks = (root = document) => {
  const walker = document.createTreeWalker(
    root,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode(node) {
        const parent = node.parentElement;

        if (!parent) {
          return NodeFilter.FILTER_REJECT;
        }

        // 入力欄やコード内は変換しない
        if (
          parent.closest(
            'script, style, textarea, input, select, option, code, pre'
          )
        ) {
          return NodeFilter.FILTER_REJECT;
        }

        const text = node.nodeValue ?? '';

        if (!text.includes('[br-sp]') && !text.includes('[br-pc]')) {
          return NodeFilter.FILTER_REJECT;
        }

        return NodeFilter.FILTER_ACCEPT;
      },
    }
  );

  /** @type {Text[]} */
  const targetNodes = [];

  while (walker.nextNode()) {
    if (walker.currentNode.nodeType === Node.TEXT_NODE) {
      targetNodes.push(/** @type {Text} */ (walker.currentNode));
    }
  }

  targetNodes.forEach((node) => {
    const text = node.nodeValue ?? '';
    const fragment = document.createDocumentFragment();

    const parts = text.split(/(\[br-sp\]|\[br-pc\])/g);

    parts.forEach((part) => {
      if (part === '[br-sp]') {
        const br = document.createElement('br');
        br.className = 'br-sp';
        fragment.appendChild(br);
      } else if (part === '[br-pc]') {
        const br = document.createElement('br');
        br.className = 'br-pc';
        fragment.appendChild(br);
      } else if (part !== '') {
        fragment.appendChild(document.createTextNode(part));
      }
    });

    if (node.parentNode) {
      node.parentNode.replaceChild(fragment, node);
    }
  });
};

const initResponsiveBreaks = () => {
  replaceResponsiveBreaks(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          if (node.parentNode) {
            replaceResponsiveBreaks(node.parentNode);
          }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          replaceResponsiveBreaks(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initResponsiveBreaks);
} else {
  initResponsiveBreaks();
}